<sh-modal #infoModal id='info-modal' [attr.label]="'chatbot.infoModal.title' | transloco" modal-height='80vh' modal-width='75vw'>
  <div class="info-modal__content">
    <sh-text id="chatbot-text-43">{{ 'chatbot.infoModal.description' | transloco }}</sh-text>
    <br />

    <div class="info-modal__section-header">
      <sh-text id="chatbot-text-44" class="title-300">{{ 'chatbot.infoModal.productsTitle' | transloco }}</sh-text>
    </div>

    <table class="info-modal__table">
      <tr>
        <th>{{ 'chatbot.infoModal.table.instrumentGroup' | transloco }}</th>
        <th>{{ 'chatbot.infoModal.table.chatbotSupport' | transloco }}</th>
        <th>{{ 'chatbot.infoModal.table.dataSupport' | transloco }}</th>
      </tr>
      @for (product of instrumentInformation; track product.instrumentName + '-' + product.version) {
        <tr>
          <td>{{product.instrumentName}}</td>
          <td>{{product.version}}</td>
          <td><sh-icon id="chatbot-icon-45" [icon]="product.dataApiName ? 'success' : null" size="xs"></sh-icon></td>
        </tr>
      }
    </table>
    <br />

    <div class="info-modal__section-header">
      <sh-text id="chatbot-text-46" class="title-300">{{ 'chatbot.infoModal.versionsTitle' | transloco }}</sh-text>
    </div>

    @for (capability of aiCapabilities; track capability) {
      <sh-text id="chatbot-text-47" [innerHTML]="capability | markdown" size="body-1"></sh-text>
    }

    <br />
  </div>

  <sh-button id="chatbot-button-48" slot='footer' [attr.label]="'chatbot.infoModal.gotIt' | transloco" color="secondary"
  (click)="infoModal.visible = false"></sh-button>
</sh-modal>